export default __webpack_public_path__ + "static/DMSans-Italic-fad57cf26b1b39afdcdc866774cb45c2.woff2";